import { render, staticRenderFns } from "./excludeStudent.vue?vue&type=template&id=88803bd4&"
import script from "./excludeStudent.vue?vue&type=script&lang=js&"
export * from "./excludeStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports